import { z } from 'zod';

export type ReferralCode = {
  id: number;
  code: string;
  description: string;
  totalReferralCount: number;
  signupCount: number;
  onboardedUserCount: number;
  hackathonRegistrationCount: number;
  createdAt: Date;
};

export type GetReferralMetricsResponse = {
  totalReferralCount: number;
  signupCount: number;
  onboardedUserCount: number;
  hackathonRegistrationCount: number;
  referralCodes: ReferralCode[];
  recentEvents: {
    user: {
      username: string;
      displayName: string;
      avatarUrl: string;
      email: string;
      country: string;
      city: string;
    };
    id: number;
    code: string;
    eventType: string;
    createdAt: Date;
  }[];
};

export const createEditReferralSourceSchema = z.object({
  code: z.string().regex(/^[a-zA-Z0-9_-]+$/, {
    message:
      'Code must only contain alphanumeric characters, underscores, or hyphens',
  }),
  description: z.string().optional().default(''),
});

export type CreateReferralSourceBody = z.infer<
  typeof createEditReferralSourceSchema
>;

export type EditReferralSourceBody = z.infer<
  typeof createEditReferralSourceSchema
>;

export type CreateReferralSourceResponse = {
  id: number;
  code: string;
  description: string;
  createdAt: Date;
};

export type EditReferralSourceResponse = CreateReferralSourceResponse;

export type DeleteReferralSourceResponse = {
  message: string;
};
